'use strict';

DynamicGridGridFactory.$inject = ['$q', 'mx.SolutionBuilderAgent.BaseGrid', 'mx.SolutionBuilderAgent.MxGridHelperService'];
export default function DynamicGridGridFactory($q, BaseGrid, gridHelperService) {
	class DynamicGrid extends BaseGrid {
		constructor() {
			super();
		}

		initProperties() {
			super.initProperties();

			var data = [],
				columns = [],
				showAddButton = false,
				showRemoveButton = false;
			this.removeButtonHidden = true;
			this.createButtonHidden = true;

			Object.defineProperties(this, {
				showAddButton: {
					// obsolete attribute
					configurable: true,
					get: function () {
						return showAddButton;
					},
					set: function (newValue) {
						if (typeof newValue !== 'boolean') {
							return;
						}
						showAddButton = newValue;
						this.createButtonHidden = !newValue;
					},
				},
				showRemoveButton: {
					// obsolete attribute
					configurable: true,
					get: function () {
						return showRemoveButton;
					},
					set: function (newValue) {
						if (typeof newValue !== 'boolean') {
							return;
						}
						showRemoveButton = newValue;
						this.removeButtonHidden = !newValue;
					},
				},

				addButtonHidden: {
					configurable: true,
					get: function () {
						return true;
					},
					set: function () {},
				},
				items: {
					get: function () {
						return data;
					},
				},
				data: {
					configurable: true,
					get: function () {
						return data;
					},
					set: function (newData) {
						data = newData;

						if (this.executor) {
							this.updateRequest();
							this.debouncedLoadItems();
						}
					},
				},
				columns: {
					configurable: true,
					get: function () {
						return columns;
					},
					set: function (newData) {
						columns = Array.isArray(newData) ? newData : [];

						if (this.executor) {
							var dq = gridHelperService.initStaticDQ(columns);
							this.executor.setDataQuery(dq);
						}
					},
				},
			});
		}

		async initDataQuery() {
			return gridHelperService.initStaticDQ(this.columns);
		}

		updateRequest() {
			if (this.executor) {
				this.executor.updateRequestOptions({
					items: this.items,
					hideItemFieldName: this.hideItemFieldName,
				});
			}
		}

		beforeEntityCreated(entity) {
			this._internalCreatingEntity = entity;
			this.items.push(entity);
		}

		_removeEntitiesFromData(entities) {
			mx.components.Utils.removeItemsFromArray(this.items, entities);
		}

		afterEntityCreationCancelled(entity) {
			this._internalCreatingEntity = null;
			this._removeEntitiesFromData([entity]);
		}

		afterEntitiesCreated(/*entities*/) {
			this._internalCreatingEntity = null;
			if (typeof this.items.changed === 'function') {
				this.items.changed();
			}
		}

		removeEntities(entities) {
			this._removeEntitiesFromData(entities);

			this.updateRequest();
			return this.loadItems();
		}
	}

	return DynamicGrid;
}
